import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import * as CryptoJS from "crypto-js";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService implements CanActivate {
  constructor(private router: Router) {}
  encrypted_data: any;
  canActivate() {
    if (localStorage.getItem(environment.localStorageKey)) {
      // this.encrypted_data = localStorage.getItem(environment.localStorageKey);
      // this.encrypted_data = JSON.parse(
      //   CryptoJS.AES.decrypt(
      //     this.encrypted_data,
      //     environment.secretkey
      //   ).toString(CryptoJS.enc.Utf8)
      // );
      this.router.navigate(["/"]);
      return false;
      // if (!this.encrypted_data.subscription_type) {
      //   this.router.navigate(["/subscription"]);
      //   return false;
      // } else {
      //   return true;
      // }
    } else {
      return true;
    }
  }
}
